import styled from 'styled-components'

const StyledMediaByUrlDialog = styled.div``

export default StyledMediaByUrlDialog
